var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 13.25H22.25L23.75 14.75H26.75C27.1642 14.75 27.5 15.0858 27.5 15.5V26C27.5 26.4142 27.1642 26.75 26.75 26.75H13.25C12.8358 26.75 12.5 26.4142 12.5 26V15.5C12.5 15.0858 12.8358 14.75 13.25 14.75H16.25L17.75 13.25ZM20 25.25C22.4853 25.25 24.5 23.2353 24.5 20.75C24.5 18.2647 22.4853 16.25 20 16.25C17.5147 16.25 15.5 18.2647 15.5 20.75C15.5 23.2353 17.5147 25.25 20 25.25ZM20 23.75C18.3431 23.75 17 22.4068 17 20.75C17 19.0932 18.3431 17.75 20 17.75C21.6568 17.75 23 19.0932 23 20.75C23 22.4068 21.6568 23.75 20 23.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.318335827c300aac565165cb20a750ee.svg";
export { ForwardRef as ReactComponent };